export default "__VITE_ASSET__CybZN4La__"